export default __webpack_public_path__ + "e4d287fdc7be3fa2c22a2ee513d4c116.woff";